export const LANGUAGE = {
  'EN': 'en'
}